import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Text, Flex, Container, Table } from '@radix-ui/themes';
import api from '../../api/axios.js';

const UsersProgress = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await api.get(`/users`);
            setUsers(response.data);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching users:', err);
            setError(err.message);
            setLoading(false);
        }
    };

    const handleUserDoubleClick = (userId) => {
        navigate(`/progress/${userId}`);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <Container size="3">
            <Box style={{ padding: '2rem' }}>
                <Flex justify="between" align="center" mb="4">
                    <Text size="6" weight="bold">ความคืบหน้าในการเรียนของพนักงาน</Text>
                    <Flex gap="2">
                        <Button onClick={() => navigate('/backend/lessons')} style={{ cursor: 'pointer' }}>
                            กลับไปบทเรียนทั้งหมด
                        </Button>
                        <Button 
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid limegreen', cursor: 'pointer' }} 
                            // onClick={() => window.open(`${process.env.REACT_APP_API_URL}/api/download/exam-users`, '_blank')}
                            onClick={() => window.open(`${process.env.REACT_APP_API_URL}/api/download/user-exam-summary`, '_blank')}
                        >
                            <img src="/images/download.png" alt="download" style={{ width: '20px', height: '20px' }} />
                            ดาวน์โหลด
                        </Button>
                    </Flex>
                </Flex>

                <Table.Root>
                    <Table.Header>
                        <Table.Row>
                            <Table.ColumnHeaderCell>Username</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Position</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Branch</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Team</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Role</Table.ColumnHeaderCell>
                            <Table.ColumnHeaderCell>Last Update</Table.ColumnHeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {users.map((user) => (
                            <Table.Row 
                                key={user.id} 
                                onDoubleClick={() => handleUserDoubleClick(user.id)}
                                style={{ 
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: 'var(--gray-a2)'
                                    }
                                }}
                            >
                                <Table.Cell>{user.username}</Table.Cell>
                                <Table.Cell>{`${user.firstname} ${user.lastname}`}</Table.Cell>
                                <Table.Cell>{user.position}</Table.Cell>
                                <Table.Cell>{user.Branch?.name || '-'}</Table.Cell>
                                <Table.Cell>{user.Team?.name || '-'}</Table.Cell>
                                <Table.Cell>{user.is_admin ? 'Admin' : 'User'}</Table.Cell>
                                <Table.Cell>{new Date(user.update_at).toLocaleDateString()}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table.Root>
            </Box>
        </Container>
    );
};

export default UsersProgress;
